import { Globe2, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { images, PHONE_TEL } from "@/data/marvinContent";

export const Header = ({ t, lang, setLang }) => {
  const navItems = [
    ["services", t.nav.services],
    ["pricing", t.nav.pricing],
    ["gallery", t.nav.gallery],
    ["estimate", t.nav.estimate],
  ];

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/92 backdrop-blur-xl">
      <div className="section-shell flex min-h-[72px] items-center justify-between gap-3 py-3">
        <a data-testid="header-brand-link" href="#top" className="group flex min-w-0 items-center gap-3" aria-label="Marvin Plumbing home">
          <span data-testid="brand-mark" className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-2xl bg-white shadow-lg shadow-blue-950/15 ring-1 ring-slate-200">
            <img data-testid="brand-logo-image" src={images.logo} alt="Marvin Plumbing logo" className="h-10 w-10 object-contain" />
          </span>
          <span className="min-w-0">
            <span data-testid="brand-name" className="block truncate font-heading text-lg font-extrabold tracking-tight text-[#0A2540] sm:text-xl">Marvin Plumbing</span>
            <span data-testid="header-emergency-text" className="hidden text-xs font-bold uppercase tracking-[0.2em] text-amber-600 sm:block">{t.header.emergency}</span>
          </span>
        </a>

        <nav data-testid="desktop-navigation" className="hidden items-center gap-1 lg:flex" aria-label="Primary navigation">
          {navItems.map(([id, label]) => (
            <a key={id} data-testid={`nav-link-${id}`} href={`#${id}`} className="rounded-full px-4 py-2 text-sm font-bold text-slate-600 transition-colors hover:bg-slate-100 hover:text-[#0A2540]">
              {label}
            </a>
          ))}
        </nav>

        <div className="flex shrink-0 items-center gap-2">
          <button
            data-testid="language-toggle-button"
            type="button"
            onClick={() => setLang(lang === "en" ? "es" : "en")}
            className="inline-flex min-h-11 items-center gap-1 rounded-full border border-slate-200 bg-white px-3 text-xs font-extrabold text-slate-700 shadow-sm transition-transform hover:-translate-y-0.5 hover:border-amber-300"
            aria-label="Switch language"
          >
            <Globe2 className="h-3.5 w-3.5" aria-hidden="true" />
            <span data-testid="language-toggle-current">{lang.toUpperCase()}</span>
            <span className="text-slate-300">|</span>
            <span>{lang === "en" ? "ES" : "EN"}</span>
          </button>
          <Button data-testid="header-call-button" asChild className="min-h-12 rounded-full bg-amber-500 px-4 font-extrabold text-[#0A2540] shadow-lg shadow-amber-500/25 transition-transform hover:-translate-y-0.5 hover:bg-amber-600 sm:px-5">
            <a href={`tel:${PHONE_TEL}`} aria-label={t.header.call}>
              <Phone className="h-4 w-4" aria-hidden="true" />
              <span className="hidden sm:inline">{t.header.call}</span>
              <span className="sm:hidden">{t.header.shortCall}</span>
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
};